(function () {
  function initVariantOptions(root) {
    if (!(root instanceof HTMLElement) || root.dataset.novaVariantOptionsReady) return;

    const variantData = root.querySelector('[data-nova-variant-data]');
    const scope = root.closest('.shopify-section');
    const form = document.getElementById(root.dataset.productFormId);
    const variantInput = form?.querySelector('[data-nova-variant-id]');
    const choices = Array.from(root.querySelectorAll('[data-nova-option-value]'));

    if (!(variantData instanceof HTMLScriptElement)) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent || '[]');
    } catch {
      return;
    }

    if (!Array.isArray(variants)) return;
    root.dataset.novaVariantOptionsReady = 'true';

    function selectedValues() {
      return Array.from(root.querySelectorAll('.nova-variant-option')).map((group) => {
        return group.querySelector('.is-active')?.dataset.novaOptionValue || '';
      });
    }

    function syncVariant() {
      const values = selectedValues();
      const variant = variants.find((candidate) => {
        return candidate.options?.every((value, index) => value === values[index]);
      });

      if (variantInput instanceof HTMLInputElement) {
        variantInput.value = variant ? String(variant.id) : '';
        variantInput.disabled = !variant;
      }
      // form.elements includes the sticky purchase button outside the form.
      Array.from(form?.elements || []).filter((element) => element.type === 'submit').forEach((button) => {
        button.disabled = !variant?.available;
        button.textContent = !variant
          ? root.dataset.unavailableLabel
          : variant.available ? button.dataset.availableLabel : root.dataset.soldOutLabel;
      });
      scope?.querySelectorAll('[data-nova-cart-product-option]').forEach((option) => {
        const index = Number(option.dataset.novaCartProductOption);
        option.textContent = values[index] || '';
      });
      const price = variant && root.querySelector(`[data-nova-variant-price="${variant.id}"]`);
      scope?.querySelectorAll('.nova-price').forEach((container) => {
        if (price) container.replaceChildren(price.content.cloneNode(true));
        container.hidden = !variant;
      });
    }

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const group = choice.closest('.nova-variant-option');
        group?.querySelectorAll('[data-nova-option-value]').forEach((button) => {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });
        choice.classList.add('is-active');
        choice.setAttribute('aria-pressed', 'true');
        syncVariant();
      });
    });

    syncVariant();
  }

  function initVariantOptionGroups() {
    document.querySelectorAll('[data-nova-variant-options]').forEach(initVariantOptions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantOptionGroups, { once: true });
  } else {
    initVariantOptionGroups();
  }

  document.addEventListener('shopify:section:load', initVariantOptionGroups);
})();
